'use strict';

angular.module('app')
  .service('HomePage', function($http, $location, $timeout, utils, gettextCatalog, Request, DestinationModel, GTM, urlMaker) {
    var HomePage = {},
      _this = this;

    _this.searchUrl = '';

    HomePage.search = function(value) {
      return Request.get('search/homepage/', value).then(function(req) {
        var shops = [],
          locations = [],
          fleets = [],
          travelGuides = [];

        _.each(req.data, function(item, key) {
          if (item.modelType === 'Shop') {
            shops.push(item);
          } else if (item.modelType === 'Geo-Location' || item.modelType === 'Location') {
            if (!locations.length) {
              item.firstRow = true;
            }

            locations.push(item);

            if (item.modelType === 'Location' && value.kind === "scubaguide") {
              var scubaGuide = _.clone(item);

              scubaGuide.modelType = 'Travel guides';
              scubaGuide.title += ' ' + gettextCatalog.getString('scuba guide');

              travelGuides.push(scubaGuide);
            }
          } else if (item.modelType === 'Fleet') {
            item.kind = 10;
            item.country = "Fleet";

            shops.push(item)
            // fleets.push(item);
          }
        });

        var shopsLength = shops.length,
          fleetLength = fleets.length,
          locationsLength = locations.length,
          lastDiveResortIndex,lastDiveCenterIndex,lastLiveaboardIndex,
          firstDiveResortIndex,firstDiveCenterIndex,firstLiveaboardIndex;

        // travelGuidesLength = travelGuides.length;
        if (shopsLength) {
          lastDiveResortIndex = _.findLastIndex(shops, {
            kind: 20
          });
          lastDiveCenterIndex = _.findLastIndex(shops, {
            kind: 0
          });
          lastLiveaboardIndex = _.findLastIndex(shops, {
            kind: 10
          });

          // find first index
          firstDiveResortIndex = _.findIndex(shops, {
            kind: 20
          });
          firstDiveCenterIndex = _.findIndex(shops, {
            kind: 0
          });
          firstLiveaboardIndex = _.findIndex(shops, {
            kind: 10
          });

          if (shops[lastDiveResortIndex]) {
            shops[lastDiveResortIndex].last = true;
          }

          if (shops[lastDiveCenterIndex]) {
            shops[lastDiveCenterIndex].last = true;
          }

          if (shops[lastLiveaboardIndex]) {
            shops[lastLiveaboardIndex].last = true;
          }

          if (shops[firstDiveResortIndex]) {
            shops[firstDiveResortIndex].firstRow = true;
          }
          if (shops[firstDiveCenterIndex]) {
            shops[firstDiveCenterIndex].firstRow = true;
          }
          if (shops[firstLiveaboardIndex]) {
            shops[firstLiveaboardIndex].firstRow = true;
          }
        }

        if (locationsLength) {
          locations[0].firstRow = true;
          locations[locationsLength - 1].last = true;
        }

        if (fleetLength) {
          fleets[0].firstRow = true;
          fleets[fleetLength - 1].last = true;
        }

        if (value.kind === 'scubaguide') {
          return travelGuides;
        }

        return locations.concat(shops).concat(fleets);
      }, function(err) {
        return err;
      });
    };

    HomePage.headerSearch = function(value) {
      return Request.get('search/homepage/', value).then(function(req) {
        var shops = [],
          liveaboards = [],
          geoLocations = [],
          locations = [],
          travelGuides = [],
          fleets = [],
          locationsCount = _.filter(req.data, function(item){
            return item.modelType === 'Geo-Location' || item.modelType === 'Location'
          });

        _.each(req.data, function(item, key) {
          item.order = key;
          if (item.modelType === 'Shop' && item.kind !== 10) {
            shops.push(item);
          } else if (item.modelType === 'Shop' && item.kind === 10) {
            liveaboards.push(item);
          } else if (item.modelType === 'Geo-Location' || item.modelType === 'Location') {
            if (!locations.length) {
              item.firstRow = true;
            }

            var title = _.clone(item.title);

            if (locationsCount.length > 1) {
              item.title = gettextCatalog.getString('Dive operators {{ location }}', {location: item.inTitle });
              locations.push(item);
            } else {
              if (item.hasLiveaboards) {
                item.firstRow = !locations.length;
                item.title = gettextCatalog.getString('Liveaboards {{ location }}', {location: item.inTitle });
                item.searchKind = 'LA';
                locations.push(_.clone(item));
              }

              if (item.hasDiveResorts) {
                item.firstRow = !locations.length;
                item.title = gettextCatalog.getString('Dive resorts {{ location }}', {location: item.inTitle });
                item.searchKind = 'DR';
                locations.push(_.clone(item));
              }

              if (item.hasDiveCenters) {
                item.firstRow = !locations.length;
                item.title = gettextCatalog.getString('Dive centers {{ location }}', {location: item.inTitle });
                item.searchKind = 'DC';
                locations.push(_.clone(item));
              }

              if (item.hasDiveSites) {
                item.firstRow = !locations.length;
                item.title = gettextCatalog.getString('Dive sites {{ location }}', {location: item.inTitle });
                item.searchKind = 'DS';
                locations.push(_.clone(item));
              }
            }

            if (item.modelType === 'Location' && item.hasScubaguide) {
              var scubaGuide = _.clone(item);

              scubaGuide.modelType = 'Travel guides';
              scubaGuide.title = gettextCatalog.getString('{{ location }} scuba guide', { location: title });

              travelGuides.push(scubaGuide);
            }
          } else if (item.modelType === 'Fleet' && !fleets.length) {
            item.kind = 10;
            item.name = "Fleet";

            fleets.push(item);
          }
        });
        shops = _.sortBy(shops, 'order', 'desc');

        var shopsLength = shops.length,
          fleetLength = fleets.length,
          locationsLength = locations.length,
          lastDiveResortIndex,lastDiveCenterIndex,lastLiveaboardIndex,
          firstDiveResortIndex,firstDiveCenterIndex,firstLiveaboardIndex,
          travelGuidesLength = travelGuides.length;

        if (shopsLength) {
          lastDiveResortIndex = _.findLastIndex(shops, {
            kind: 20
          });
          lastDiveCenterIndex = _.findLastIndex(shops, {
            kind: 0
          });
          // lastLiveaboardIndex = _.findLastIndex(shops, {
          //   kind: 10
          // });

          // find first index
          firstDiveResortIndex = _.findIndex(shops, {
            kind: 20
          });
          firstDiveCenterIndex = _.findIndex(shops, {
            kind: 0
          });
          // firstLiveaboardIndex = _.findIndex(shops, {
          //   kind: 10
          // });

          if (shops[lastDiveResortIndex]) {
            shops[lastDiveResortIndex].last = true;
          }

          if (shops[lastDiveCenterIndex]) {
            shops[lastDiveCenterIndex].last = true;
          }

          // if (shops[lastLiveaboardIndex]) {
          //   shops[lastLiveaboardIndex].last = true;
          // }

          if (shops[firstDiveResortIndex]) {
            shops[firstDiveResortIndex].firstRow = true;
          }
          if (shops[firstDiveCenterIndex]) {
            shops[firstDiveCenterIndex].firstRow = true;
          }
          // if (shops[firstLiveaboardIndex]) {
          //   shops[firstLiveaboardIndex].firstRow = true;
          // }
        }

        if (liveaboards.length) {
          liveaboards[0].firstRow = true;
          liveaboards = liveaboards.concat(fleets);

          liveaboards[liveaboards.length - 1].last = true;
        } else {
          liveaboards = liveaboards.concat(fleets);
        }

        if (locationsLength) {
          locations[0].firstRow = true;
          if (locationsCount == 1) {
            locations[locationsLength - 1].last = true;
          } else {
            locations[locationsLength - 1].last = true;
          }
          
          if (travelGuidesLength) {
            travelGuides[0].firstRow = true;
            travelGuides[travelGuidesLength - 1].last = true;
          }
        }

        // if (fleetLength) {
        //   fleets[0].firstRow = true;
        //   fleets[fleetLength - 1].last = true;
        // }

        if (value.kind === 'scubaguide') {
          return travelGuides;
        }

        if (value.kind === 10) {
          return liveaboards.concat(shops).concat(locations);
        }

        return locations.concat(travelGuides).concat(liveaboards).concat(shops);
      }, function(err) {
        return err;
      });
    };

    HomePage.reviewAutoSuggest = function(value) {
      return Request.get('shop/autosuggest/', value).then(function(req) {
        var lastDiveResortIndex = _.findLastIndex(req.data, function(el) {
            return el.kind == '20'
          }),
          lastDiveCenterIndex = _.findLastIndex(req.data, function(el) {
            return el.kind == '0'
          }),
          lastLiveaboardIndex = _.findLastIndex(req.data, function(el) {
            return el.kind == '10'
          });

        if (req.data[lastDiveCenterIndex]) {
          req.data[lastDiveCenterIndex].last = true;
        }
        if (req.data[lastDiveResortIndex]) {
          req.data[lastDiveResortIndex].last = true;
        }
        if (req.data[lastLiveaboardIndex]) {
          req.data[lastLiveaboardIndex].last = true;
        }

        return req.data;
      }, function(err) {
        return err;
      });
    };

    HomePage.autoSuggestResults = function(item, kind, noredirect) {
      var url = '',
        type,
        location = item.area;
      if (item.modelType === 'Shop') {
        if (item.kind == 0) {
          url += '/dive-center';
        } else if (item.kind == 10) {
            // url += '/liveaboard';
            type = 'la_page'
            location = item.country;
        } else if (item.kind == 20) {
            type = 'dr_page'
            // url += '/dive-resort';
            location = item.country;
        } else if (item.kind === 30) {
            url += '/dive-sites';
        }

        _this.searchUrl = utils.createURL(type, {
            location: location,
            slug: item.slug
        })
      } else if (item.modelType === 'Travel guides') {
        _this.searchUrl = utils.createURL('destination', { location: item.slug });
      } else if (item.modelType === 'Fleet') {
        _this.searchUrl = utils.createURL('fleets', { slug: item.slug });
      } else {
        if (kind == 0) {
          type = 'dive-centers';
        } else if (kind == 10) {
          type = 'search_la';
        } else if (kind == 20) {
          type = 'search_dr';
        } else if (kind === 30) {
          url = 'dive-sites';
        }

        _this.searchUrl = utils.createURL(type, { slug: item.slug });
      }

      if (noredirect && (kind == 10 && type === 'search_la') || (kind == 20 && type === 'search_dr')) {
        return 0
      }
      
      HomePage.startSearch();
    };

    HomePage.startSearch = function(val) {
      if (val == '88005553535') {
        localStorage.setItem('testMode', 'prod');
        window.location.reload();
      } else if (val == '88005553536') {
        localStorage.setItem('testMode', false);
        window.location.reload();
      } else if (val == 'activateHybrid') {
        localStorage.setItem('hybrid', 'true');
        window.location.reload();
      } else if (val == 'deactivateHybrid') {
        localStorage.setItem('hybrid', false);
        window.location.reload();
      } else if (val === 'telega ept') {
        $('h1').addClass('wobble animated').html('telega inc.');
        $('.logo').addClass('hinge animated');
        $('.homepage-bg').addClass('wobble animated').css({
          'background-image': 'url(http://brewnotesik.narod.ru/IMG_0418.jpg)'
        });

        $('body').append('<img src="https://s-media-cache-ak0.pinimg.com/originals/ae/37/49/ae3749f99e14dfc0c55ca5062d5d9f3f.gif" id="magic-id">')
        var elem = $('#magic-id');
        elem.css({
          position: 'fixed',
          top: '50%',
          left: '50%',
          'margin-left': '-312.5px',
          'margin-top': '-162.5px',
          'z-index': 99999
        });

        $timeout(function() {
          elem.remove();
        }, 10000);
        $('ul li').addClass('hinge animated');
      }
      if (_this.searchUrl) {
        $location.path(_this.searchUrl).hash('').search({});

        _this.searchUrl = '';
      } else {
        return true;
      }
    };

    HomePage.getDestinations = function() {
      return Request.get('home/destinations/').then(function(req) {
        var preparedData = {
          firstDestination: req.data[0],
          allData: req.data,
          data: []
        };

        _.each(req.data, function(elem, key) {
          if (key != 0) {
            preparedData.data.push(elem);
          }
        });

        return preparedData;
      });
    };

    HomePage.getDeals = function() {
      return Request.get('home/deals/').then(function(req) {
        // var preparedData = {
        //     firstDeal: req.data[0],
        //     deals: [],
        //     bigBanner: req.data[5]
        //   },
        //   ecommerce = {
        //     currencyCode: "USD",
        //     impressions: []
        //   };
        //
        // for (var i in req.data) {
        //   var val = req.data[i];
        //
        //   ecommerce.impressions.push({
        //     brand: val.shopTitle,
        //     price: val.price,
        //     list: "Homepage Features",
        //     position: +i + 1,
        //   });
        //
        //   if (i != 0 && i < 5) {
        //     preparedData.deals.push(val);
        //   }
        // }
        //
        // GTM.products(null, ecommerce);

        return req.data;
      });
    };

    HomePage.generateLink = function(item) {
      if (!item) {
        return false;
      }
      var url = '',
        location = item.shopArea;

      if (item.shopKind == 0) {
        url += '/dive-center';
      } else if (item.shopKind == 10) {
        url += '/liveaboard';
        location = item.shopCountry;
      } else if (item.shopKind == 20) {
        url += '/dive-resort';
      } else if (item.shopKind === 30) {
        url += '/dive-sites';
      }

      return url + '/' + location + '/' + item.shopSlug + '/';
    };

    HomePage.sendContactForm = function(data) {
      return Request.post('contact-us/', data).then(function(data) {
        return data;
      });
    };

    HomePage.getPromotions = function (data) {
      return Request.get('promotions/homepage/',data).then(function (res) {
        _.each(res.data.results, function(val){
          _.remove(val.promotions,function(v){
              return !v.priceData;
          });

          val.promotions = _.sortBy(val.promotions,'value').reverse();
        });

        return res.data;
      });
    };


    HomePage.getScubaList = function() {
      return Request.get('home/top-10/').then(function(res) {
        return res.data;
      });
    }

    return HomePage;
  });
